import { VisuallyHidden } from "@99tech/ui";
import { Box, BoxProps, styled } from "@mui/material";
import React from "react";
import { BigBrandLogo, Line, WarningText } from "src/assets";
import { createStyles, isMobile } from "src/main/utils";

interface LoginProps extends React.PropsWithChildren {}

const FlexImageBox = styled(Box)<BoxProps>(() => ({
  img: {
    maxHeight: "100%",
    maxWidth: "100%",
  },
  justifyContent: "center",
  display: "flex",
}));

const LandingPage: React.FC<LoginProps> = (props) => {
  return (
    <Box sx={styles.root}>
      <VisuallyHidden as="h1">Moo555</VisuallyHidden>

      <Box sx={styles.container}>
        <FlexImageBox height="25vh">
          <img
            alt="moo555 brand logo"
            src={BigBrandLogo}
            style={{ alignSelf: "center" }}
          />
        </FlexImageBox>

        <img
          alt="warning text"
          src={WarningText}
          width={368}
          style={{
            alignSelf: "center",
            zIndex: 1,
          }}
        />

        <img
          alt="line"
          src={Line}
          width={200}
          style={{
            alignSelf: "center",
            cursor: "pointer",
            zIndex: 1,
          }}
          onClick={() => window.open("https://m555th.com/cs", "_blank", isMobile() ? "width=full,height=full" : "")}
        />
      </Box>
    </Box>
  );
};

const styles = createStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100vh",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: "80vh",
    paddingTop: "40px",
  },
});

export default LandingPage;
